import { AxiosResponse } from 'axios';
import api from '../api';
import { DefaultResponse } from '../interfaces/index';

export interface ResponseUserInfo extends DefaultResponse {
  data: {
    address?: string;
    birthdate?: string;
    created_at?: string;
    creator_id?: string;
    default_institution_id?: string;
    email?: string;
    esign_code?: string;
    expired_at?: string;
    fullname?: string;
    gender?: number;
    his_id?: string;
    id: string;
    institution_ids: string[];
    institutions: string[];
    is_super?: boolean;
    phone?: string;
    roles?: string[];
    signature?: string;
    status?: number;
    title?: string;
    updated_at?: string;
    username: string;
  };
}

export const getUserInfo = async () => {
  const response = (await api({
    url: '/ris/users/v1/profile',
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<ResponseUserInfo>;
  const data = response?.data?.data || {};

  console.log(`🤡 CURRENT USER \n`, data);

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push({
    event: 'login',
    username: data?.username,
    fullname: data?.fullname,
    is_super: data?.is_super,
  });

  return data as ResponseUserInfo['data'];
};
